import React, { FunctionComponent, useState } from 'react';
import InlineMessaging, {
  InlineMessagingTheme,
} from '@havenengineering/module-shared-library/dist/components/InlineMessaging/InlineMessaging';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import { handleGTMGiveMeACall } from '../../helpers/googleTag';
import { EnquiryResult, OwnerDetails } from '../../types/part-exchange';

interface GiveMeACallButtonProps {
  enquiryDetails: OwnerDetails;
  subject: string;
  buttonText?: string;
}

const GiveMeACallButton: FunctionComponent<GiveMeACallButtonProps> = ({
  enquiryDetails,
  subject,
  buttonText = 'Give me a call',
}) => {
  const [sendingEnquiry, setSendingEnquiry] = useState<boolean>(false);
  const [enquiryResult, setEnquiryResult] = useState<EnquiryResult | null>(
    null
  );

  const handleGiveMeACall = () => {
    setSendingEnquiry(true);
    setEnquiryResult({
      type: 'success',
      title: 'Thank you',
      message: 'We have received your enquiry.',
    });
    setSendingEnquiry(false);
    handleGTMGiveMeACall({
      successFlag: 'success',
      sectionTitle: subject,
    });
  };

  return (
    <>
      {enquiryDetails && (!enquiryResult || enquiryResult.type === 'error') && (
        <Button
          size="large"
          onClick={() => handleGiveMeACall()}
          data-testid="giveMeACallButton"
          includeChevron
          isLoading={sendingEnquiry}
        >
          {buttonText}
        </Button>
      )}

      {enquiryResult && (
        <InlineMessaging
          type={
            enquiryResult.type === 'success'
              ? InlineMessagingTheme.SUCCESS_THEME
              : InlineMessagingTheme.ERROR_THEME
          }
          title={enquiryResult.title}
          message={enquiryResult.message}
          dismissible={false}
        />
      )}
    </>
  );
};

export default GiveMeACallButton;
